import React, { Fragment } from "react";
import { MapPin } from "lucide-react";

const Address = ({
  address,
  removeAddress,
  setActiveAddress,
  setNewAddress,
}) => {
  const item = address && address.length > 0 ? address[0] : null;
  return (
    <div className="address-class">
      <div className="address-data">
        <Fragment>
          <button
            className="address-data-list active"
            key={item.Id}
            //onClick={() => setActiveAddress(item)}
            onClick={setNewAddress}
          >
            {/* <img
              loading="lazy"
              className="delete"
              onClick={(e) => {
                e.stopPropagation(); 
                removeAddress();
              }}
              src={globalFileIcon + "deleteLocationAndListI.svg"}
              alt="delete"
            /> */}
            <span className="location-icon" aria-hidden>
              <MapPin size={18} strokeWidth={2} />
            </span>
            <span className="location-name">{item.name}</span>
            <span className="location-address-name">
              {`${item.streetName} ${item.houseNumber}, דירה ${item.apartment}`}
              <br />
              {item.zipCode}
            </span>
          </button>
          {/*
          <button
            style={{
              backgroundImage: `url(${globalFileIcon + "addressGrayBg.svg"})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "100%",
              backgroundColor: "transparent",
            }}
            onClick={setNewAddress}
            className="add-new-address"
          >
            <img
              loading="lazy"
              className="location-add-icon"
              src={globalFileIcon + "addNewAddressAndList.svg"}
              alt="add"
            />
            <span className="location-add-name">הוספת כתובת</span>
          </button>
          */}
        </Fragment>
      </div>
    </div>
  );
};

export default Address;
